@use '../../styling/colors.scss' as *;

/* stylelint-disable */
:export {
  colorcomplete: $color-primary-green;
  colorincomplete: $color-warning-orange;
}
/* stylelint-enable */
.chartContainerStyle {
  position: 'relative';
  min-height: 8em;
}
